import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  FormControl,
  Alert,
} from "@mui/material";
import Langs from "../../../../../app/lang/langs";
import { CustomColorPicker } from "../../../../../components/inputs/CustomColorPicker";
import { INPUT_SX, SELECT_SX } from "../constants";
import { minutesToTimeStr, timeStrToMinutes } from "../utils/formHelpers";
import FieldRow from "./FieldRow";

export default function SampleLeaveBody({
  selectedFormData,
  formError,
  settings,
  handlers,
  dataFns,
  handleColorChange,
}) {
  const {
    onTimeFromChange,
    onTimeToChange,
    handleLeaveTypeChange,
    onFromDayPeriodChange,
    onToDayPeriodChange,
  } = handlers;

  const { getSelectedDayPeriod, getFromDayPeriodOptions, getToDayPeriodOptions } = dataFns;

  return (
    <Box sx={{ px: 2.5, pt: 2, pb: 12 }}>
      {/* Start time + day period */}
      <FieldRow label="START_TIME">
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <TextField
            type="time"
            size="small"
            value={minutesToTimeStr(selectedFormData.timeFrom)}
            onChange={(e) => onTimeFromChange(timeStrToMinutes(e.target.value))}
            sx={{ ...INPUT_SX, flex: 1 }}
            inputProps={{ style: { fontSize: "16px" } }}
          />
          <FormControl size="small" sx={{ ...SELECT_SX, minWidth: 120 }}>
            <Select
              value={getSelectedDayPeriod(parseInt(selectedFormData.timeFrom / 60))}
              onChange={(e) => onFromDayPeriodChange(e.target.value)}
              sx={{ fontSize: "16px" }}
            >
              {getFromDayPeriodOptions().map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  <Langs str={opt.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </FieldRow>

      {/* End time + day period */}
      <FieldRow label="END_TIME">
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <TextField
            type="time"
            size="small"
            value={minutesToTimeStr(selectedFormData.timeTo)}
            onChange={(e) => onTimeToChange(timeStrToMinutes(e.target.value))}
            sx={{ ...INPUT_SX, flex: 1 }}
            inputProps={{ style: { fontSize: "16px" } }}
          />
          <FormControl size="small" sx={{ ...SELECT_SX, minWidth: 120 }}>
            <Select
              value={getSelectedDayPeriod(parseInt(selectedFormData.timeTo / 60))}
              onChange={(e) => onToDayPeriodChange(e.target.value)}
              sx={{ fontSize: "16px" }}
            >
              {getToDayPeriodOptions().map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  <Langs str={opt.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </FieldRow>

      {/* Type */}
      <FieldRow label="TYPE" error={formError === "MISSING_TYPE"}>
        <TextField
          fullWidth
          size="small"
          value={selectedFormData.type || ""}
          onChange={handleLeaveTypeChange}
          error={formError === "MISSING_TYPE"}
          inputProps={{ maxLength: 50, style: { fontSize: "16px" } }}
          sx={INPUT_SX}
        />
      </FieldRow>

      {/* Color */}
      <FieldRow label="COLOR">
        <Box
          sx={{
            p: 1.5,
            borderRadius: "12px",
            border: "1px solid rgba(0,0,0,0.08)",
            bgcolor: "rgba(255,255,255,0.6)",
          }}
        >
          <CustomColorPicker
            color={selectedFormData.color}
            colors={settings.leavesColors}
            onChange={handleColorChange}
          />
        </Box>
      </FieldRow>

      {/* Error */}
      {formError && (
        <Alert severity="error" sx={{ mt: 2, borderRadius: "12px", fontSize: "0.85rem" }}>
          <Langs str={formError} />
        </Alert>
      )}
    </Box>
  );
}
